export default __webpack_public_path__ + "static/media/img10.d575edfe.JPG";